import React from 'react';
import { EventProps } from 'react-big-calendar';
import { DocumentTemplateType } from '../../api-client/autogenerated';

export interface EventType {
  id: string;
  projectId: string;
  title: string;
  start: Date;
  end: Date;
  allDay?: boolean;
  source?: string;
  company?: string;
  type?: DocumentTemplateType;
  typeReadable?: string;
  parentId?: string;
  parentType?: DocumentTemplateType;
  documentIndexRow?: any;
}

interface CalendarEventProps extends EventProps<EventType> {}

const getTitleColor = (title: any) => {
  switch (title) {
    case 'Approved':
      return '#128750';
    case 'Rejected':
      return '#ED3F26';
    default:
      return '#464546';
  }
};

export default function CalendarEvent(props: CalendarEventProps) {
  const { event } = props;

  return (
    <div
      style={{
        background: '#EDECEC',
        color: '#464546',
        textTransform: 'none',
        lineHeight: '17px',
      }}
    >
      <div style={{ fontWeight: 'bold', whiteSpace: 'pre-line' }}>
        {event.typeReadable} {event.source}
      </div>
      <div
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          fontWeight: 'bold',
          color: getTitleColor(event.title),
        }}
      >
        {event.title}
      </div>
      <div
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {event.company}
      </div>
    </div>
  );
}
